// Direct pair-URL boot kickoff, called from main.tsx before createRoot.
//
// On a direct token-page load, three things used to wait for React's first
// commit: the PairPage lazy chunk, the read-only /resolve round-trip, and the
// websocket handshake (WsContext module). All three are URL-derived and
// side-effect-free w.r.t. rendered state, so they start during bundle
// evaluation instead. The seed itself is NOT started here: it must stay
// behind the exact-pool subscribe ACK (subscribe-before-seed — the seed's
// liquidity-activity section has no coverage proof).
//
// Chained to the resolve answer (still before mount):
//   - the exact pair:{pool} WS channels subscribe (ACK already in hand when
//     usePairFeed's barrier asks — the barrier itself is unchanged),
//   - the chart's initial 1m/USD candle seed fires (no coverage dependency).

import { sharedWsClient } from '../ws/WsContext'
import { startPairOhlcvPrefetch } from './pairOhlcvPrefetch'
import { loadPairPage } from './pairPagePreload'
import { peekPairResolvePrefetch, startPairResolvePrefetch } from './pairResolvePrefetch'
import { pairRouteRefFromPathname } from './pairRoutes'
import { startPairWsBootstrap } from './pairWsBootstrap'

export function kickoffPairRouteBoot(pathname: string): void {
  const ref = pairRouteRefFromPathname(pathname)
  if (!ref) return
  void loadPairPage().catch(() => undefined)
  startPairResolvePrefetch(ref.addr, ref.mode)
  // The WS bootstrap touches the shared socket singleton; like WsContext's
  // module-init connect, it stays out of test runners (jsdom leaks real
  // sockets and reconnect timers otherwise).
  if (import.meta.env.MODE !== 'test' && typeof WebSocket !== 'undefined') {
    startPairWsBootstrap(sharedWsClient(), ref)
  }
  // Candles need only the resolved pool. Peek (never consume) the resolve
  // prefetch: usePairFeed remains the sole consumer of the entry.
  const resolved = peekPairResolvePrefetch(ref.addr, ref.mode)
  if (!resolved) return
  void resolved.then(
    (route) => {
      if (route?.pool_addr) startPairOhlcvPrefetch(route.pool_addr)
    },
    () => undefined
  )
}
